import { TBranding } from '@fe-core';
import { publishHeaderBranding } from '@fe-core-events';

export const useHeaderBranding = ({
  branding,
}: {
  branding?: TBranding | null;
}) => {
  if (!branding) return;
  publishHeaderBranding({
    logoUrl: branding?.logoUrl,
    primaryColor: branding?.cpPrimaryColor,
    navColor: branding?.cpNavColor,
  });
};
